import { requestService } from 'shared/utils/services/requestService';

export const registerEmailNewsletter = (email) => {
  return requestService({
    url: '/web-api/v1/email_registration/register',
    method: 'post',
    data: { email },
  });
};
